import { render, staticRenderFns } from "./LINK.vue?vue&type=template&id=990c9a56&scoped=true&"
import script from "./LINK.vue?vue&type=script&lang=js&"
export * from "./LINK.vue?vue&type=script&lang=js&"
import style0 from "./LINK.vue?vue&type=style&index=0&id=990c9a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990c9a56",
  null
  
)

export default component.exports